// extracted by mini-css-extract-plugin
module.exports = {"orders_list":"orders-list_orders_list__2iTPK flex_column pr-2 scroll"};